import { AfterViewInit, Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from "@angular/forms";
import { Subscription } from 'rxjs';
import { ApiService } from "../../../services/api/api.service";
import { SettingsService } from '@gatho/services/api/settings.service';
import { SiteConfigDTO } from '@shared/models/SiteConfigDTO';
import { User } from "@shared/models/User";
import { UserService } from "../../../services/user/user.service";
import {
  MatDialog,
} from '@angular/material/dialog';
import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";
import { BrandingService } from '@gatho/services/branding/BrandingService';
import { ExternalAuthPlatforms } from '@shared/models';
import { environment } from 'src/environments/environment';
import { LocalMediaService } from '@gatho/features/lobby/services/media/LocalMediaService';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {
  public logoPath: string = '../../../../assets/images/logos/gatho-logo-gradient.svg';
  public backgroundPath: string = '../../../../assets/images/opener-bg.jpg';
  public hide = true;
  public loading = false;
  public errorMessage?: string;
  public passwordNeedsReset?:string;
  public payload = {
    email: "",
    password: ""
  };

  renderLogo = false;

  public settings: SiteConfigDTO = {} as SiteConfigDTO;
  private settingsSub?: Subscription;

  constructor(private _route: Router,
              private _api: ApiService,
              private _userService: UserService,
              private _settings: SettingsService,
              private _localMediaService: LocalMediaService,
              private _matDialog: MatDialog,
              private matDialog: MatDialog,
              private _branding: BrandingService,
              private _elementRef: ElementRef
  ) {
    this.getSettings();
    this.setBranding();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.renderLogo = true;
    }, 2000);
  }

  ngOnInit(): void {

  }

  /* Get the application settings. */
  async getSettings() {
    // Retrieve settings from backend
    try {
      this.settingsSub = this._settings.settings$.subscribe((data) => {
        this.settings = data;
      });
    } catch (err) {
      console.log('err', err);
    }
  }

  setBranding() {
    this.logoPath = this._branding.getBrandingSetting('siteLogo') ?? this.logoPath;
    this.backgroundPath = this._branding.getBrandingSetting('loginBackground') ?? this.backgroundPath;
    this._branding.setCssProperty(this._elementRef, '--login-logo-max-width-desk', 'loginLogoMaxWidthDesk');
    this._branding.setCssProperty(this._elementRef, '--login-logo-max-width-mob', 'loginLogoMaxWidthMob');
    this._branding.setCssProperty(this._elementRef, '--login-links-background-color', 'loginLinksBackgroundColor');
    this._branding.setCssProperty(this._elementRef, '--login-links-background-opacity', 'loginLinksBackgroundOpacity');
  }

  openGetPassword() {
    const dialogConfig = {
      maxWidth: '44rem',
      width: '44rem',
      panelClass: ['gathoDialog'],
    };
    this.matDialog.open(ForgotPasswordComponent, dialogConfig);
  }

  navigateToSignUp() {
    this._route.navigate(['sign-up']);
  }


  validateEmail(email: string) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }


  checkEmailIsFromImportedUser = async (f: NgForm) => {
    this.passwordNeedsReset = '';
    //console.log(f);
    const email = f.value.email;
   if (email) {
     if (this.validateEmail(email)) {
       try {
         const response = await this._api.checkEmailForImportedUser(email);
         if (response.package && response.package.result) {
           const isImported = response.package.result;
           if (isImported === 'yes') {
             this.passwordNeedsReset = isImported;
           }
         }
       } catch (e) {

       }
     }
   }
  }

  onSubmit(f: NgForm): void{
    if(f.valid){
      this.loading = true;
      delete this.errorMessage;
      const email = f.value.email;
      const password = f.value.password;
      this._api.login(email, password).then((user: User) => {
        user.doNotDisturb = this._localMediaService.dndStatus;
        user.videoStatus = this._localMediaService.videoStatus;
        this._userService.save(user);
        this.loading = false;

        const login_dest_url = localStorage.getItem('login_dest_url');
        if (login_dest_url) {
          localStorage.removeItem('login_dest_url');
          this._route.navigateByUrl(login_dest_url);
        }else{
          this._route.navigate(['']);
        }

      }).catch((e: Error) => {
        this.loading = false;
        this.errorMessage = "Your email or password is incorrect. Please try again.";
        this.payload.email = email;
        this.payload.password = password;
      });
    }
  }

  platformLoginUrl(platform: ExternalAuthPlatforms) {
    return `${environment.api_url}/login/${platform}`;
  }

  ngOnDestroy(): void {
    this.settingsSub?.unsubscribe();
  }
}
